export enum TrustCenterPolicyActionEnum {
  EDIT = "TRUST_CENTER_TRUST_CENTER_ACTION_ENUM_EDIT",
  DELETE = "TRUST_CENTER_TRUST_CENTER_ACTION_ENUM_DELETE",
  PUBLISH = "TRUST_CENTER_TRUST_CENTER_ACTION_ENUM_PUBLISH",
  DRAFT = "TRUST_CENTER_TRUST_CENTER_ACTION_ENUM_DRAFT",
}
